import { render, staticRenderFns } from "./CadastroTerritorio.vue?vue&type=template&id=3f21eb42&lang=pug"
import script from "./CadastroTerritorio.vue?vue&type=script&lang=js"
export * from "./CadastroTerritorio.vue?vue&type=script&lang=js"
import style0 from "./CadastroTerritorio.vue?vue&type=style&index=0&id=3f21eb42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports